module.exports = __webpack_public_path__ + "static/product-pa200-coyote-tan-60961fd1eab38aba11bf8e536d904108.png";